<template>
  <div>
    <van-nav-bar
      class="backBox"
      title="课程"
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="content_box">
      <div class="course_box">
        <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
          success-text="刷新成功"
          :disabled="errorFlag"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            :error.sync="error"
            error-text="请求失败，点击重新加载"
            @load="onLoad"
          >
            <div
              class="course_item"
              v-for="item in courseList"
              :key="item.id"
              @click="toPiano(item)"
            >
              <div class="left">
                <div class="time">{{ item.set_useTime }}</div>
                <div class="floor">
                  {{ item.set_address }}
                </div>
              </div>
              <div class="right">
                <i class="iconfont icon-erweima"></i>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from '../../api/api'
import * as common from '../../api/common'
import * as utils from '../../api/utils'
import { Toast } from 'vant'
export default {
  data () {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      errorFlag: false,
      pageOption: {
        total: 0,
        page_no: 1,
        page_size: 15
      },
      courseList: [],
      recordListData: []
    }
  },
  mounted () {
    this.queryList()
  },
  computed: {

  },
  methods: {
    toPiano (row) {
      this.$router.push({
        path: '/appointmentDetails',
        query: {
          bookId: -1,
          isCourse: 1,
          roomId: row.room_id,
          showTime: encodeURIComponent(row.set_useTime),
          showAddress: encodeURIComponent(row.set_address)
        }
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    queryList () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const para = {
        page_no: this.pageOption.page_no,
        page_size: this.pageOption.page_size
      }
      api
        .axiosRequest(api.urlList.getPianoCourse, para)
        .then((res) => {
          if (res.code === common.resCode.OK) {
            if (res.list && res.list.length > 0) {
              res.list.forEach((item) => {
                const startTime = utils.formatDate(item.begin_time)
                const endTime = utils.formatDate(item.end_time)
                item.set_useTime = utils.formatTimeMDChinese(startTime) + ' ' + utils.formatTimeHourMinutes(startTime) + ' - ' + utils.formatTimeHourMinutes(endTime)
                item.set_address = item.building_no + ' ' + item.name
              })

              this.pageOption.total = res.total
              this.courseList.push(...res.list)
              this.loading = false
              this.refreshing = false
              Toast.clear()
              if (this.courseList.length >= this.pageOption.total) {
                this.finished = true
              }
            } else {
              if (res.list.length === 0) {
                this.courseList = []
                this.loading = false
                this.finished = true
                this.refreshing = false
              }
            }
          } else {
            this.error = true
            this.errorFlag = true
            this.loading = false
            this.refreshing = false
            utils.judgeBackMsg(res)
          }
        })
        .catch((e) => {
          console.log('error log:', e)
        })
        .finally(() => {
          Toast.clear()
        })
    },
    onLoad () {
      // 监听到即执行
      console.log('滑到底了')

      //   再次调用 查询 下一页数据
      if (this.refreshing) {
        // 下拉刷新
        this.pageOption.page_no = 1
        this.queryList()
      } else {
        // 错误后点击刷新
        if (this.errorFlag) {
          // 说明上次加载失败 现在重新加载
          this.pageOption.page_no = 1
          this.errorFlag = false
          this.queryList()
          return false
        }
        // 触底加载
        if (this.courseList.length >= this.pageOption.total) {
          this.finished = true
        } else {
          this.pageOption.page_no = this.pageOption.page_no + 1
          this.queryList()
        }
      }
    },
    onRefresh () {
      this.courseList = []
      this.finished = false
      this.loading = true
      this.onLoad()
    }

  }
}
</script>
<style scoped lang="scss">
.content_box {
  width: 100%;
  height: 100%;
  .course_box {
    height: 100%;
    padding: 1rem 0;
    .course_item {
      padding: 1rem;
      background-color: #fafafa;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .time {
        font-size: 18px;
        color: #333;
      }
      .floor {
        font-size: 14px;
        color: #666;
        margin-top: 0.5rem;
      }
      .right i {
        font-size: 1.875rem;
        color: #666;
      }
    }
  }
}
</style>
